import { getCookie } from './getCookie';

export const getFbCookie = () => {
  const fbp = getCookie('_fbp');
  const fbc = getCookie('_fbc');

  return { fbp, fbc };
};
